import PropTypes from 'prop-types';
import { wrapCompositeType, wrapType } from './util.js';
const any = wrapType(PropTypes.any, { type: 'any' });
const array = wrapType(PropTypes.array, { type: 'array' });
const bool = wrapType(PropTypes.bool, { type: 'bool' });
const element = wrapType(PropTypes.element, { type: 'element' });
const func = wrapType(PropTypes.func, { type: 'func' });
const list = wrapType(PropTypes.array, { type: 'list' });
const node = wrapType(PropTypes.node, { type: 'node' });
const number = wrapType(PropTypes.number, { type: 'number' });
const object = wrapType(PropTypes.object, { type: 'object' });
const string = wrapType(PropTypes.string, { type: 'string' });
const symbol = wrapType(PropTypes.symbol, { type: 'symbol' });
const baseRecordOf = () => object;
const wrappedArrayOf = wrapCompositeType(PropTypes.arrayOf, { type: 'arrayOf' }, true);
const wrappedExact = wrapCompositeType(PropTypes.exact, { type: 'exact' });
const wrappedInstanceOf = wrapCompositeType(PropTypes.instanceOf, { type: 'instanceOf' }, true);
const wrappedObjectOf = wrapCompositeType(PropTypes.objectOf, { type: 'objectOf' }, true);
const wrappedOneOf = wrapCompositeType(PropTypes.oneOf, { type: 'oneOf' });
const wrappedOneOfType = wrapCompositeType(PropTypes.oneOfType, { type: 'oneOfType' }, true);
const wrappedRecordOf = wrapCompositeType(baseRecordOf, { type: 'recordOf' }, true);
const wrappedShape = wrapCompositeType(PropTypes.shape, { type: 'shape' }, true);
const wrapperList = wrapCompositeType(PropTypes.arrayOf, { type: 'list' }, true);
function arrayOf(type) {
    return wrappedArrayOf(type);
}
function exact(model) {
    return wrappedExact(model);
}
function instanceOf(clazz) {
    return wrappedInstanceOf(clazz);
}
function objectOf(type) {
    return wrappedObjectOf(type);
}
function oneOf(values) {
    return wrappedOneOf(values);
}
function listOf(type) {
    return wrapperList(type).unique();
}
function oneOfType(values) {
    return wrappedOneOfType(values);
}
function recordOf([key, value]) {
    return wrappedRecordOf([key, value]);
}
function shape(model) {
    return wrappedShape(model);
}
export { any, array, bool, element, func, list, node, number, object, string, symbol, arrayOf, exact, instanceOf, listOf, objectOf, oneOf, oneOfType, recordOf, shape, };
//# sourceMappingURL=type-checkers.js.map